<template>
  <div class="opple-auth" :class="{ inlineBlock: inline }" :style="extendsStyle">
    <slot v-if="status === 1" />
  </div>
</template>

<script>

function checkPermission(key, allPermission = '') {
  const code = key.startsWith('Opple_') ? key : `Opple_${key}`
  //console.log('checkPermission', code, allPermission.includes(code), allPermission);

  return allPermission.includes(code);
}

export function checkAreaLoadData(gpno, store) {
  // 如果没有传 gpno (默认 -1) 或者 store 不存在，直接视为通过区域校验，走老逻辑
  if (!gpno || !store) return true;

  try {
    const areasGpName = store.state.areasGpName || {};
    // 只有明确查到了该节点，且 LoadData 为 false 时，才拦截（返回 false）
    // 如果节点不存在，返回 true 
    const areaInfo = areasGpName[gpno];
    if (areaInfo && areaInfo.LoadData === false) {
      return false;
    }
  } catch (e) {
  }
  return true;
}

export function isExistPermission(code, isPassPermission = false, gpno, store) {
  // 欧洲部分不走权限细分
  if (isPassPermission) return true;
  const userinfor = getLocalStoragItem('userinfor');

  if (!userinfor || !code) {
    return false;
  }

  try {
    const info = JSON.parse(userinfor);
    const Power = info.Power || '';

    if (code.includes(',')) {
      // 多个权限 有一个就展示
      const codes = code.split(',');
      const isExist = codes.some(item => checkPermission(item, Power));

      return isExist;
      // this.status = isExist ? 1 : 0;

    } else {
      // 单个权限
      const isExist = checkPermission(code, Power);

      // this.status = isExist ? 1 : 0;

      return isExist;
    }
  } catch (e) {

  }
}


export default {
  components: {
  },
  props: {
    // eslint-disable-next-line vue/no-reserved-props
    // style: {
    //   type: Object,
    //   default: () => ({})
    // },
    extendsStyle: {
      type: Object,
      default: () => ({})
    },
    code: {
      type: String,
      default: ''
    },
    inline: {
      type: Boolean,
      default: false
    },
    forceShow: {
      type: Boolean,
      default: false
    },
    gpno: {
      type: Number,
      default: -2
    }
  },
  data() {
    return {
      status: 0 ,// 0 不可见  1 可见 // 1 不可编辑 2 可以编辑
    };
  },
  watch: {
    forceShow() {
      this.checkPermission();
    },
    gpno(val) { 
      this.checkPermission(); 
    }
  },
  mounted() {
    this.checkPermission();
  },
  methods: {
    checkPermission() {
      if (this.forceShow) {
        this.status = 1;
        return;
      }
      
      const hasRight = checkAreaLoadData(this.gpno, this.$store)

      if(!hasRight){
        this.status = 0;
        return;
      }

      const isExist = isExistPermission(this.code);
  
      this.status = isExist ? 1 : 0;
    }
  }
};
</script>

<style scoped="scoped" lang="scss">
.opple-auth {
  &.inlineBlock {
    display: inline-block;
  }
}
</style>
